import React from 'react';
import { use100vh } from 'react-div-100vh';
import { useStyles } from './TextImageModalSkeleton.styles';
import { Grid, Skeleton } from '@mui/material';

const TextImageModalSkeleton = (): JSX.Element => {
  const viewHeightValue = use100vh();
  const viewHeightStyle = viewHeightValue
    ? `${viewHeightValue / 16}rem`
    : '100%';
  const classes = useStyles({ viewHeight: viewHeightStyle });
  return (
    <div className={classes.modal_data}>
      <Skeleton variant="text" className={classes.modal_title}></Skeleton>
      <Grid container>
        <Grid item xs={12} md={6} className={classes.modal_image_area}>
          <Skeleton
            variant="rectangular"
            className={classes.modal_image}
          ></Skeleton>
        </Grid>
        <Grid item xs={12} md={6} className={classes.modal_text_area}>
          <div className={classes.text_description}>
            <div className={classes.modal_text}>
              <div>
                <Skeleton
                  variant="text"
                  className={classes.text_skeleton}
                ></Skeleton>
                <Skeleton
                  variant="text"
                  className={classes.text_skeleton}
                ></Skeleton>
                <Skeleton
                  variant="text"
                  className={classes.text_skeleton}
                ></Skeleton>
                <Skeleton
                  variant="text"
                  className={classes.text_skeleton}
                ></Skeleton>
              </div>
              <br />
              <div>
                <Skeleton
                  variant="text"
                  className={classes.bullet_skeleton}
                ></Skeleton>
                <Skeleton
                  variant="text"
                  className={classes.bullet_skeleton}
                ></Skeleton>
              </div>
              <Skeleton
                variant="rectangular"
                className={classes.button_container}
              ></Skeleton>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default TextImageModalSkeleton;
